import { ProjectDocumentModel } from "../models/ProjectDocumentModel";
import API from "./API";

const ProjectDocumentService = {
  async getProjectDocumentsByProjectId(projectId: number) {
    const response = await API().get("ProjectDocument", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data.filter(
      (cur_ProjectDocument: ProjectDocumentModel) =>
        cur_ProjectDocument.projectId === projectId
    );
  },
};

export default ProjectDocumentService;
